import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    let container = $(this.element)

		let types = {
			rss: { title: 'RSS', selector: 'rss+xml' },
			json: { title: 'JSON', selector: 'json' }
		}

		$.each(types, function(key, value) {
			$('link[type="application/' + value.selector + '"]').each(function() {
				let feed_link = $('<a>' + value.title + '</a>')
				feed_link.addClass('auto_discoveries__discovery_link')
				feed_link.addClass('auto_discoveries__discovery_link--' + key)
				feed_link.attr('title', $(this).attr('title'))
				feed_link.attr('href', $(this).attr('href'))
				container.append(feed_link)
			})
		})
  }
}
